import { render, staticRenderFns } from "./ViewPushNotificationModal.vue?vue&type=template&id=4e88a267"
import script from "./ViewPushNotificationModal.vue?vue&type=script&lang=js"
export * from "./ViewPushNotificationModal.vue?vue&type=script&lang=js"
import style0 from "./ViewPushNotificationModal.vue?vue&type=style&index=0&id=4e88a267&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports